export const voltarAoTopo = () => {
  try {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    })
  } catch (err) {
    console.log('Não foi possível mover a tela')
  }

}

export function validarEdicaoWaTelefone(waTelefoneAntigo = null, waTelefoneAtual = null, waAceiteNotificacaoChecked = false) {
  const waTelefoneAtualFormatado = waTelefoneAtual?.replace(/\D/g, "");

  if(!waAceiteNotificacaoChecked && (waTelefoneAtualFormatado?.length > 0 && waTelefoneAtualFormatado?.length < 11)) {

    return waTelefoneAntigo;
  }

  return waTelefoneAtual;
}

export function validarWaTelefoneNumero(waTelefone) {
  const waTelefoneNumbers = waTelefone.replace(/\D/g, "");

  return (waTelefoneNumbers.length == 11) && (waTelefoneNumbers[2] == '9');
}
